import React from 'react'
import { MdClose } from 'react-icons/md'

import { UseGlobalContext } from '../../Hooks/UseContext'

const MobileMenu = () => {
  const { isMobileMenuOpen, setIsMobileMenuOpen } = UseGlobalContext()

  return (
    <>
      {isMobileMenuOpen && (
        <div
          className={` ${
            isMobileMenuOpen ? ' translate-x-0' : ' -translate-x-[2000px]'
          } p-6 flex flex-col absolute top-0 right-0 bottom-0 left-0 z-40  backdrop-blur-md h-screen w-screen dark:backdrop-filter dark:backdrop-saturate-100 dark:backdrop-brightness-50 dark:backdrop-opacity-100 dark:backdrop-contrast-100 dark:backdrop-blur-0`}
          whileInView={{ x: [300, 0] }}
          transition={{ duration: 0.85, ease: 'easeInOut' }}
        >
          <MdClose
            onClick={() => setIsMobileMenuOpen(false)}
            className='w-12 h-12 md:w-20 md:h-20 object-fit cursor-pointer dark:text-white text-primary'
          />
          <ul
            className='list-none flex flex-col items-center font-semibold gap-12 mt-20'
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {['home', 'about', 'work', 'skills', 'testimonails', 'contact'].map(
              (link) => (
                <li
                  className={`dark:text-white text-gray-500 capitalize hover:text-white text-[18px] font-medium`}
                  key={`link-${link}`}
                >
                  <a href={`#${link}`}>{link}</a>
                </li>
              )
            )}
          </ul>
        </div>
      )}
    </>
  )
}

export default MobileMenu
